import PersonaPage from "./PersonaPage";
import { questionsPersonMale } from "./questions";

const faq = [
  {
    q: "Wie schreibt man eine Trauerrede für den Vater?",
    a: "Beginnen Sie nicht mit dem Datum, sondern mit einer Geste — ein Werkzeug in seinen Händen, ein Satz, den er oft sagte, ein Sonntagsritual. Von dort aus öffnet sich die Rede von selbst.",
  },
  {
    q: "Mein Vater war ein stiller Mann. Wie soll ich lange über ihn sprechen?",
    a: "Sie müssen es nicht. Bei stillen Menschen trägt oft eine einzige klare Geste eine ganze Rede. Wir helfen, diesen einen Moment zu finden und ihn behutsam auszuformulieren.",
  },
  {
    q: "Wir hatten kein leichtes Verhältnis. Wie ehrlich darf ich sein?",
    a: "Ehrlichkeit trägt weiter als Pathos. Eine Rede darf Distanz benennen — sie muss nur einen Punkt finden, an dem Respekt und Erinnerung zusammenfallen. Wir formulieren das behutsam.",
  },
  {
    q: "Können wir Zitate oder ein Vaterunser einbinden?",
    a: "Ja. Sie können im Fragebogen einen Vers, ein Gebet oder ein Zitat hinterlegen — wir binden es passend ein, ohne den Fluss zu brechen.",
  },
  {
    q: "Wie schnell erhalten wir den Entwurf?",
    a: "Sofort nach Zahlung. Der Entwurf erscheint auf dem Bildschirm, als PDF und zusätzlich per E-Mail — meist in unter zwei Minuten.",
  },
];

const related = [
  { label: "Trauerrede für die Mutter", to: "/trauerrede-mutter" },
  { label: "Trauerrede für den Großvater", to: "/trauerrede-opa" },
  { label: "Trauerrede für den Bruder", to: "/trauerrede-bruder" },
];

export default function TrauerredeVater() {
  return (
    <PersonaPage
      slug="trauerrede-vater"
      metaTitle="Trauerrede für den Vater schreiben — persönlich & würdevoll | Oratiorede"
      metaDescription="Eine persönliche Trauerrede für den Vater. Aus acht behutsamen Fragen entsteht ein würdevoller Entwurf — auch für stille Männer und schwierige Beziehungen. Ab 29 €."
      eyebrow="Trauerrede · Vater"
      headline={
        <>
          Eine Trauerrede für den Vater.
          <br />
          <span className="italic text-umber">In der Stimme, die er verdient hatte.</span>
        </>
      }
      intro="Für den Vater, der wenig sprach, aber viel bedeutete. Der um sechs aufstand, den Kaffee aufsetzte und leise die Tür hinter sich schloss. Ein behutsamer erster Entwurf — aus acht ruhigen Fragen und Ihren Erinnerungen an ihn."
      heroImage="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920&q=80"
      heroImageAlt="Ein Paar arbeitender Männerhände im warmen Nachmittagslicht — Sinnbild einer Trauerrede für den Vater"
      questions={questionsPersonMale}
      exampleQuote={
        <>
          „Er war kein Mann der großen Worte. Er war einer, der um sechs aufstand, den Kaffee
          aufsetzte und leise die Tür hinter sich schloss, damit niemand aufwachte. Wer ihn
          kannte, kannte diese kleine Geste — und wer sie erlebte, wusste: Da sorgt jemand.
          Ohne Aufhebens. Ein Leben lang.“
        </>
      }
      faq={faq}
      related={related}
    />
  );
}
